export const parseMessageData = (emsgData) => {
    const timestamps = emsgData.split('_');
    if (timestamps.length !== 7 ||
        !timestamps[0] ||
        !timestamps[1] ||
        !timestamps[2] ||
        !timestamps[3] ||
        !timestamps[4] ||
        timestamps[5] !== 'v') {
        return null;
    }
    return {
        packagerEnd: Number(timestamps[4]) / 1000,
        recorderEnd: Number(timestamps[1]) / 1000,
        recorderStart: Number(timestamps[0]) / 1000,
        transcoderEnd: Number(timestamps[3]) / 1000,
        transcoderStart: Number(timestamps[2]) / 1000,
    };
};
export const calculateLatency = (data) => {
    return data.time - data.recorderStart;
};
